import CONFIG from "../config/config";
import { apiFetch } from "./http";

/**
 * robotTelemetry.api.js — per-day totals for one of the caller's robots, built
 * from its finished navigation runs.
 *
 * Backend contract (controller/portalRobots.controller.js), gated by
 * verifyPortalToken and scoped to the robots this user can see — any other id
 * answers 404, the same as a robot that doesn't exist:
 *   GET /api/portal/robots/:id/telemetry/daily?from=&to=&tz=  -> { tz, from, to, days }
 *
 * Dates are YYYY-MM-DD calendar days in `tz` (an IANA name), so passing the
 * viewer's timezone gets that timezone's days back.
 */

const base = (robotId) => `${CONFIG.BASE_URL}/api/portal/robots/${robotId}/telemetry`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("portalToken")}`,
});

// Failures are thrown in the same { response: { status, data } } shape axios
// uses, so the telemetry hook words errors identically in both portals.
const getJson = async (url) => {
  const res = await apiFetch(url, { headers: authHeaders() });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw Object.assign(new Error(data?.message || `Request failed (${res.status})`), {
      response: { status: res.status, data },
    });
  }
  return data;
};

/**
 * One entry per day in [from, to], oldest first. Days without runs are present
 * with `runs: 0`; a metric no run reported is null, not 0.
 *
 * @param {string} robotId Mongo _id
 * @param {{from: string, to: string, tz: string}} params
 */
export const getDailyTelemetry = (robotId, params) =>
  getJson(`${base(robotId)}/daily?${new URLSearchParams(params)}`);
